/**
 * File size validation check
 *
 * is accepted file is less than 32MB
 *
 * @param {File} file - The input file
 * @return {boolean} - If file size is more than 32MB, return false
 */

export const isValidFileUploadSize = (file) => {
  if (file) {
    if (file.size >= 32000000) {
      return false;
    }
    return true;
  }
  return false;
};

/**
 * Total file size validation check
 *
 * is accepted total file size of 128MB or less
 *
 * @param {FileList} fileList - The list of all input files
 * @return {boolean} - If total file sizes are more than 128MB, return false
 */

export const isValidTotalFileUploadSize = (fileList) => {
  if (fileList) {
    let totalSize = 0;
    Array.from(fileList).forEach((file) => {
      totalSize += file.size;
    });
    return totalSize <= 134217728;
  }
  return false;
};

/**
 * File type validation check
 *
 * is accepted if file type is .jpg, .png, .gif, .pdf
 *
 * @param {FileList} file - The input file
 * @return {boolean} - If file type is not accepted, return false
 */
export const isValidFileUploadType = (file) => {
  const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
  if (file) {
    if (validTypes.includes(file.type)) {
      return true;
    }
  }
  return false;
};

/**
 * Checks if the file has a valid file that can be uploaded
 * 
 * @param {File} file - The input file
 * @returns {boolean} - If filename is valid, returns true. Otherwise, returns false
 */
export const isValidFileUploadName = (file) => {
  // Regex to check if it's valid filename. Add/remove special characters here if needed
  // Current known excluded characters: / : ’ 
  const VALID_FILE_NAME_REGEX = /^[\w\-.~`!@#$%^&*()_+={};"'<>,.?\|\\\[\] ]+$/

  if (VALID_FILE_NAME_REGEX.test(file.name)) {
    return true;
  }

  return false
};
